import { render, staticRenderFns } from "./ProductSalesChart.vue?vue&type=template&id=255516c6&scoped=true&lang=pug&"
import script from "./ProductSalesChart.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesChart.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesChart.vue?vue&type=style&index=0&id=255516c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255516c6",
  null
  
)

export default component.exports